<div class="session-top">
  <div class="side-content" [hidden]="!filterListContentVisible">
    <div class="field-set">
      <label label>{{ layerText }}</label>

      <app-select-box
        [(value)]="layerSelected"
        (valueChange)="onLayerSelected()"
        [items]="layerListObservable | async"
        valueExpr="layer"
        displayExpr="pathStr"
        textDisplayExpr="layer.title"
        [dropdownWidth]="isMobileScreen ? 'sync-with-target' : '50rem'"
        [showErrorEnabled]="false"
        [showClearButton]="false"
        [appBlockModalDrag]="!isMobileScreen"
      ></app-select-box>
    </div>

    <div class="fields-container">
      <app-scroll-view class="scroll-view">
        <ng-container *ngIf="!!layerSelected">
          <app-list class="filter-list" [items]="filters" [scrollable]="false">
            <ng-template
              listItem
              let-filterItem="item"
              let-filterItemIndex="index"
            >
              <div class="item">
                <div class="item-fields">
                  <div class="field-set">
                    <label label>{{ fieldText }}</label>

                    <app-select-box
                      class="select-field"
                      [(value)]="filterItem.field"
                      (valueChange)="onFieldFilterChanged(filterItem)"
                      [items]="fieldsFromLayerSelected"
                      displayExpr="alias"
                      [showErrorEnabled]="false"
                      [showClearButton]="false"
                      [appBlockModalDrag]="!isMobileScreen"
                    ></app-select-box>
                  </div>

                  <div class="field-set">
                    <label label>{{ valuesText }}</label>

                    <div
                      class="range-box"
                      *ngIf="filterItem?.field?.type === 'date'"
                    >
                      <div class="w-100">
                        <app-date-box
                          [appBlockModalDrag]="!isMobileScreen"
                          type="date"
                          class="w-100"
                          [showClearButton]="false"
                          (valueChange)="
                            onDateFieldValueFilterSelectChanged(
                              filterItem,
                              $event,
                              0
                            )
                          "
                        />
                        <p class="min-and-max">
                          {{ this.getMinorValue(filterItem.list) }}
                        </p>
                      </div>

                      <div class="w-100">
                        <app-date-box
                          type="date"
                          [appBlockModalDrag]="!isMobileScreen"
                          class="w-100"
                          [showClearButton]="false"
                          (valueChange)="
                            onDateFieldValueFilterSelectChanged(
                              filterItem,
                              $event,
                              1
                            )
                          "
                        />
                        <p class="min-and-max">
                          {{ this.getMaxValue(filterItem.list) }}
                        </p>
                      </div>
                    </div>

                    <div
                      class="range-box"
                      *ngIf="
                        filterItem?.field?.type === 'integer' ||
                        filterItem?.field?.type === 'double' ||
                        filterItem?.field?.type === 'long'
                      "
                    >
                      <div class="w-100">
                        <app-input-box
                          [appBlockModalDrag]="!isMobileScreen"
                          class="w-100"
                          type="number"
                          [showClearButton]="false"
                          [clearButtonEnabled]="false"
                          (valueChange)="
                            onNumberFieldValueFilterSelectChanged(
                              filterItem,
                              $event,
                              0
                            )
                          "
                        />

                        <p class="min-and-max">
                          {{ this.getMinorValue(filterItem.list) }}
                        </p>
                      </div>

                      <div class="w-100">
                        <app-input-box
                          [appBlockModalDrag]="!isMobileScreen"
                          class="w-100"
                          type="number"
                          [showClearButton]="false"
                          [clearButtonEnabled]="false"
                          (valueChange)="
                            onNumberFieldValueFilterSelectChanged(
                              filterItem,
                              $event,
                              1
                            )
                          "
                        />

                        <p class="min-and-max">
                          {{ this.getMaxValue(filterItem.list) }}
                        </p>
                      </div>
                    </div>

                    <div
                      *ngIf="
                        filterItem?.field?.type !== 'date' &&
                        filterItem?.field?.type !== 'integer' &&
                        filterItem?.field?.type !== 'double' &&
                        filterItem?.field?.type !== 'long'
                      "
                      class="select-value"
                      #selectValueEl
                      (click)="
                        dropDownSelectValueRef.opened =
                          !dropDownSelectValueRef.opened
                      "
                      [appBlockModalDrag]="!isMobileScreen"
                    >
                      <div class="select-value-text">
                        <app-input-box
                          [value]="filterItem.valuesText"
                          [readOnly]="true"
                          [showClearButton]="false"
                          [showErrorEnabled]="false"
                          placeholder="{{ selectValuesPlaceholder }}"
                        ></app-input-box>
                      </div>

                      <app-dropdown
                        #dropDownSelectValueRef
                        [target]="selectValueEl"
                      >
                        <ng-template dropdownContent>
                          <div class="select-value-dropdown">
                            <app-input-box
                              class="search-box"
                              [value]="
                                filterItem.searchFilterTextObservable | async
                              "
                              (valueChange)="
                                filterItem.searchFilterTextSubject.next($event)
                              "
                              [showClearButton]="false"
                              [showErrorEnabled]="false"
                              placeholder="{{ searchPlaceholder }}"
                            ></app-input-box>

                            <app-list
                              class="list"
                              [items]="
                                filterItem.list
                                  | searchList
                                    : searchFilterValueListExpr
                                    : (filterItem.searchFilterTextObservable
                                        | async)
                              "
                              [animate]="false"
                            >
                              <ng-template listItem let-valueItem="item">
                                <div class="list-item">
                                  <app-check-box
                                    [value]="
                                      isFieldValueFilterSelected(
                                        filterItem,
                                        valueItem
                                      )
                                    "
                                    (valueChange)="
                                      onFieldValueFilterSelectChanged(
                                        filterItem,
                                        valueItem,
                                        $event
                                      )
                                    "
                                    [label]="valueItem.label"
                                  >
                                  </app-check-box>
                                </div>
                              </ng-template>
                            </app-list>
                          </div>
                        </ng-template>
                      </app-dropdown>
                    </div>
                  </div>

                  <div class="field-set">
                    <app-check-box
                      class="checkbox"
                      [label]="
                        translationService?.getCurrentLanguage().includeNull
                      "
                      (valueChange)="onIncludeNullChange($event, filterItem)"
                    />
                  </div>
                </div>

                <div
                  class="btn-remote-item"
                  [appBlockModalDrag]="!isMobileScreen"
                >
                  <app-button
                    buttonType="danger"
                    styleType="text"
                    shapeType="circle"
                    icon="assets/icons/trash.svg"
                    (click)="onBtnDeleteFilterClick(filterItemIndex)"
                    [disabled]="!canDeleteFilterItem()"
                  ></app-button>
                </div>
              </div>
            </ng-template>
          </app-list>

          <div class="btn-add-item">
            <app-button
              buttonType="normal"
              styleType="text"
              sizeType="large"
              shapeType="circle"
              icon="assets/icons/circle-plus.svg"
              (click)="onBtnAddFilterClick()"
              [appBlockModalDrag]="!isMobileScreen"
            ></app-button>
          </div>
        </ng-container>
      </app-scroll-view>
    </div>
  </div>

  <div
    class="results-container"
    #resultsContainerEl
    [hidden]="!resultsContentVisible"
  >
    <div class="tabs-container">
      <app-button
        *ngIf="isMobileScreen"
        class="btn-goback"
        buttonType="normal"
        styleType="text"
        shapeType="circle"
        icon="assets/icons/chevron-left.svg"
        (click)="onBtnGoBackClick()"
      ></app-button>

      <app-tabs
        class="tabs"
        [items]="tabs"
        [(selectedTabIndex)]="tabIndexSelected"
        [fillModeEnabled]="false"
        [appBlockModalDrag]="!isMobileScreen"
      ></app-tabs>
    </div>

    <ng-container *ngFor="let tab of tabs; let i = index">
      <div
        class="results-content"
        *appDeferRendering="i === tabIndexSelected"
        [hidden]="i !== tabIndexSelected"
      >
        <app-results-table-view
          [layer]="tab.data.layer"
          [fields]="tab.data.fields"
          [resultList]="tab.data.features"
          [(elementsSelected)]="tab.data.featuresSelected"
          (onSelectedChanged)="onFeaturesSelectedChanged(tab, $event)"
        ></app-results-table-view>
      </div>
    </ng-container>
  </div>
</div>

<div class="actions-bottom">
  <app-scroll-view class="scroll-view" [horizontal]="true" [vertical]="false">
    <div class="btn-item" [appBlockModalDrag]="!isMobileScreen">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="{{ bufferText }}"
        [disabled]="isBtnBufferDisabled"
        (click)="onBtnBufferClick()"
      ></app-button>
    </div>

    <div class="btn-item" [appBlockModalDrag]="!isMobileScreen">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="{{ symbologyText }}"
        (click)="onBtnHighlightConfigClick()"
      ></app-button>
    </div>

    <div class="btn-item" [appBlockModalDrag]="!isMobileScreen">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="{{ zoomText }}"
        (click)="onBtnZoomToClick()"
      ></app-button>
    </div>

    <div
      class="btn-item"
      [appBlockModalDrag]="!isMobileScreen"
      *ngIf="isBtnExportXlsxVisible"
    >
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text=".XLSX"
        [disabled]="isBtnExportDisabled"
        (click)="onBtnExportXlsxClick()"
      ></app-button>
    </div>

    <div
      class="btn-item"
      [appBlockModalDrag]="!isMobileScreen"
      *ngIf="isBtnExportKmlVisible"
    >
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text=".KML"
        [disabled]="isBtnExportDisabled"
        (click)="onBtnExportKmlClick()"
      ></app-button>
    </div>

    <div
      class="btn-item"
      [appBlockModalDrag]="!isMobileScreen"
      *ngIf="isBtnExportShpVisible"
    >
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text=".SHP"
        [disabled]="isBtnExportDisabled"
        (click)="onBtnExportShpClick()"
      ></app-button>
    </div>

    <div class="btn-item" [appBlockModalDrag]="!isMobileScreen">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="{{ clearText }}"
        (click)="onBtnClearClick()"
      ></app-button>
    </div>

    <div class="btn-item" [appBlockModalDrag]="!isMobileScreen">
      <app-button
        buttonType="primary"
        styleType="contained"
        sizeType="small"
        text="{{ applyText }}"
        (click)="onBtnApplyClick()"
        [disabled]="isBtnFilterDisabled"
      ></app-button>
    </div>
  </app-scroll-view>
</div>

<app-loading-panel
  *ngIf="!initialSearchWithGeometryMode"
  [visible]="loadingController.changes | async"
  [container]="resultsContainerEl"
  [overlayMask]="false"
></app-loading-panel>

<app-highlight-config-form
  [(visible)]="highlightConfigModalVisible"
  [(value)]="highlightConfigGroup"
  (valueChange)="onHighlightConfigChanged()"
></app-highlight-config-form>

<app-buffer-form
  [(visible)]="bufferFormModalVisible"
  [(value)]="bufferConfigGroup"
  (valueChange)="onBufferParamsApplyClick()"
></app-buffer-form>
